import { AnchorHTMLAttributes, Fragment, ReactNode } from 'react'
import { cn } from '../../lib/utils'

const navItems = [
  {
    url: '/coding',
    label: 'Coding Questions',
    base: 'platform',
    dropdown: [
      { url: '/coding', label: 'Analytical Questions', base: 'platform' },
      { url: '/algorithms', label: 'Algorithm Questions', base: 'platform' },
      {
        url: '/visualizations',
        label: 'Visualization Questions',
        base: 'platform',
      },
    ],
  },
  {
    url: '/technical',
    label: 'Non-coding Questions',
    base: 'platform',
    dropdown: null,
  },
  {
    url: '/data-projects',
    label: 'Data Projects',
    base: 'platform',
    dropdown: null,
  },
  { url: '/guides', label: 'Guides', base: 'gatsby', dropdown: null },
  { url: '/blog', label: 'Blog', base: 'gatsby', dropdown: null },
  { url: '/pricing', label: 'Pricing', base: 'platform', dropdown: null },
] as const

export type LinkRenderFn = (
  props: AnchorHTMLAttributes<HTMLAnchorElement>,
) => ReactNode

interface Props {
  pathname: string | undefined
  renderPlatformLink: LinkRenderFn
  renderGatsbyLink: LinkRenderFn
}

function Nav({ pathname, renderPlatformLink, renderGatsbyLink }: Props) {
  return (
    <ul className="Header__primary-ul flex">
      {navItems.map((item) => {
        if (item.dropdown) {
          const activeDropdown = item.dropdown.some(({ url }) =>
            pathname?.startsWith(url),
          )
          return (
            <Fragment key={item.url}>
              <li className="Header__primary-item text-sm">
                <div
                  className={cn(
                    'Header__primary-link cursor-pointer text-neutral-500',
                    activeDropdown && 'active',
                  )}
                >
                  {item.label}
                </div>
                <div className="Header__dropdown absolute flex flex-col rounded-md shadow">
                  {item.dropdown.map((subItem) => {
                    const active = pathname?.startsWith(subItem.url)
                    const props = {
                      className: cn(
                        'Header__primary-link text-neutral-500 p-4',
                        active && 'active',
                      ),
                      children: subItem.label,
                      href: subItem.url,
                    }
                    return (
                      <div
                        key={subItem.url}
                        className="Header__primary-item text-sm"
                      >
                        {renderPlatformLink(props)}
                      </div>
                    )
                  })}
                </div>
              </li>
            </Fragment>
          )
        }
        const active = pathname?.startsWith(item.url)
        const props = {
          className: cn(
            'Header__primary-link text-neutral-500',
            active && 'active',
          ),
          children: item.label,
          href: item.url,
        }
        return (
          <li key={item.url} className="Header__primary-item text-sm">
            {item.base === 'platform' && renderPlatformLink(props)}
            {item.base === 'gatsby' && renderGatsbyLink(props)}
          </li>
        )
      })}
    </ul>
  )
}

export default Nav
